import apiClient from './client';

export async function fetchTournaments(search = '') {
  const params = search.trim() ? { search: search.trim() } : {};
  const { data } = await apiClient.get('/competition-applications/tournaments', { params });
  return data;
}

/** 관리자: 대회별 참가자 (memberId 포함) */
export async function fetchTournamentParticipants(tournamentId) {
  const { data } = await apiClient.get(
    `/admin/competition-applications/tournaments/${tournamentId}/participants`
  );
  return data;
}

/** 참가 신청 + (이름, 연락처) 기준 회원 등록/연결 */
export async function applyCompetition(payload) {
  const { data } = await apiClient.post('/competition-members/apply', payload);
  return data;
}

/** 관리자: 참가 취소 */
export async function cancelCompetitionApplication(id) {
  await apiClient.delete(`/admin/competition-applications/${id}`);
}
